import React, { useState, useEffect } from 'react';
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { Button, Flex, Input, Upload, Select, Spin } from 'antd';
import {
    CAvatar,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from '@coreui/react'
import { getStyle, hexToRgba } from '@coreui/utils'
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import CIcon from '@coreui/icons-react'
import axios from 'axios';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const baseURL = apiUrls.baseURL;

const WorkingGroupFinancialChartReport = () => {
    //const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

    const [mountaineeringData, setMountaineeringData] = useState([]);
    const [educationData, setEducationData] = useState([]);
    const [trialData, setTrialData] = useState([]);
    const [climbingData, setClimbingData] = useState([]);
    const [cavingData, setCavingData] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);

    useEffect(() => {
        dispatch({ type: 'set', isShow: true })
        fetchMountaineeringChart()
        fetchEducationChart()
        fetchClimbingChart()
        fetchCavingChart()
        fetchTrialChart()
    }, [])

    const fetchMountaineeringChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=2`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setMountaineeringData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchTrialChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=1`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setTrialData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchEducationChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=11`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setEducationData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchClimbingChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=3`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setClimbingData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchCavingChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=8`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setCavingData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Spin size="large" />
    }
    return (
        <div className='row'>
            <HideSidebarInMobileMode/>

            <CCol xs={12} xl={4}>
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>نمودار درآمد مالی کارگروه کوهپیمایی به تفکیک سال</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: mountaineeringData?.years,
                                datasets: [
                                    {
                                        label: 'درامد باشگاه',
                                        backgroundColor: ['#1ac9e7'],
                                        data: mountaineeringData?.clubIncomes,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>

            <CCol xs={12} xl={4}>
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>نمودار درآمد مالی کارگروه آموزش به تفکیک سال</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: educationData?.years,
                                datasets: [
                                    {
                                        label: 'درامد باشگاه',
                                        backgroundColor: ['#4ce627'],
                                        data: educationData?.clubIncomes,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>

            <CCol xs={12} xl={4}>
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>نمودار درآمد مالی کارگروه سنگنوردی به تفکیک سال</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: climbingData?.years,
                                datasets: [
                                    {
                                        label: 'درامد باشگاه',
                                        backgroundColor: ['#e2e71a'],
                                        data: climbingData?.clubIncomes,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>
            
            <CCol xs={12} xl={4}>
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>نمودار درآمد مالی کارگروه غارنوردی به تفکیک سال</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: cavingData?.years,
                                datasets: [
                                    {
                                        label: 'درامد باشگاه',
                                        backgroundColor: ['#f87979'],
                                        data: cavingData?.clubIncomes,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>

            <CCol xs={12} xl={4}>
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>نمودار درآمد مالی کارگروه آزمایشی به تفکیک سال</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: trialData?.years,
                                datasets: [
                                    {
                                        label: 'درامد باشگاه',
                                        backgroundColor: ['#d719bf'],
                                        data: trialData?.clubIncomes,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>

        </div>
    )
}

export default WorkingGroupFinancialChartReport
